module.exports = __webpack_public_path__ + "media/י.05bf68cc.mp3";